import ApisService from './index'
import { IWarehouseAdd, IWarehouseUpdate } from '../interfaces/warehouseInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createWarehouse(data: IWarehouseAdd) {
  let bodyData: any = { ...data }
  if(data.loai == "DICH"){
    delete bodyData.nccVanChuyenId
  }
  try {
    return ApisService.post('/kho/create-kho', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateWarehouse(data: IWarehouseUpdate) {
  let bodyData: any = { ...data }
  if(data.loai == "DICH"){
    delete bodyData.nccVanChuyenId
  }
  try {
    return ApisService.put('/kho/' + data.id + '/update-kho', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailWarehouse(id: string) {
  try {
    return ApisService.get('/kho/' + id + '/get-chitiet-kho')
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function getListWarehouse(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/kho/filter-kho', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteWarehouse(id: string) {
  try {
    return ApisService.delete('/kho/' + id + '/delete-kho')
  } catch (err) {
    handleError(err)
    throw err
  }
}
